import { Tooltip as ReactTooltip } from "react-tooltip"
import styled from "styled-components"

export const Content = styled.div<{ $disabled?: boolean }>`
  position: relative;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
`

export const SensorRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const SensorHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const SensorName = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #0f172a;
`

export const SensorTotal = styled.span`
  font-size: 20px;
  font-weight: 500;
  color: #0f172a;
`

export const SensorLegend = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 4px;
`

export const LegendItem = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #64748b;

  &::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ $color }) => $color};
    flex-shrink: 0;
  }
`

export const LegendStat = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
`

export const StyledInfoIcon = styled.svg`
  flex-shrink: 0;
  color: #94a3b8;
  margin-left: -8px;
  cursor: pointer;
`

export const WhiteTooltip = styled(ReactTooltip)`
  && {
    background: #fff;
    color: #475569;
    opacity: 1;
    max-width: 280px;
    padding: 4px 10px;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
    box-shadow:
      0 1px 2px 0 rgb(226 232 240 / 24%),
      0 12px 24px 0 rgb(148 163 184 / 12%);
    z-index: 1500;
    font-size: 0.75rem;
    text-align: left;
  }

  && .react-tooltip-arrow {
    border-right: 1px solid #e2e8f0;
    border-bottom: 1px solid #e2e8f0;
    z-index: -1;
  }
`

export const WidgetLoader = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`
